import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  leftCta: {
    title: 'okay',
    buttonType: 'primary',
    version: 'variable-width'
  },
  onLeftCtaPress: {
    id: 'left-cta'
  }
}, getTestId('ButtonWidgetContainer'));